/**
 * Uploaded organization images (logo + detail gallery) are rendered in
 * roughly square containers, so anything more extreme than 3:2 or 2:3 gets
 * heavily cropped or letterboxed. The picker flow surfaces a non-blocking
 * warning past those bounds; the upload itself still proceeds.
 */
export const ORGANIZATION_IMAGE_ASPECT_RATIO_MIN = 2 / 3;
export const ORGANIZATION_IMAGE_ASPECT_RATIO_MAX = 3 / 2;

/**
 * `expo-image-picker` documents that width/height can be `0` when the
 * platform did not report them — treat that as "unknown, don't warn".
 */
export const isOrganizationImageAspectRatioAcceptable = (
  width?: number,
  height?: number
): boolean => {
  if (!width || !height) return true;
  const ratio = width / height;
  return (
    ratio >= ORGANIZATION_IMAGE_ASPECT_RATIO_MIN &&
    ratio <= ORGANIZATION_IMAGE_ASPECT_RATIO_MAX
  );
};
